// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3FUKq","inputWrap":"CustomTip_inputWrap__2gVng"};